(function () {
  'use strict';

  // Maps radio value → hex color for the live preview
  var COLOR_HEX = {
    Black:  '#000000',
    Silver: '#686868',
    Gold:   '#ffc64d',
    Red:    '#991212'
  };

  // Mirrors the publishEvent shape used by utils.js / Core
  function dispatchCartAdd(items) {
    document.dispatchEvent(new CustomEvent('cart:add', {
      bubbles: false,
      cancelable: true,
      composed: true,
      detail: { sectionId: null, data: { items: items } }
    }));
  }

  // ── Modal controller ─────────────────────────────────────
  function MakeItYoursModal() {
    this.el = document.getElementById('make-it-yours-modal');
    if (!this.el) return;

    this.preview     = this.el.querySelector('[data-miy-preview]');
    this.productImg  = this.el.querySelector('[data-miy-product-image]');
    this.textInput   = this.el.querySelector('[data-miy-text]');
    this.colorRadios = Array.from(this.el.querySelectorAll('[data-miy-color]'));
    this.colorError  = this.el.querySelector('[data-miy-color-error]');
    this.addBtn      = this.el.querySelector('[data-miy-add]');
    this.laterBtn    = this.el.querySelector('[data-miy-later]');
    this.closeBtn    = this.el.querySelector('[data-miy-close]');
    this.backdrop    = this.el.querySelector('[data-miy-backdrop]');

    // Per-variant data from embedded JSON
    var jsonEl = document.getElementById('miy-variants-data');
    this._variantData = jsonEl ? JSON.parse(jsonEl.textContent) : {};

    // Populated when product-form.js dispatches make-it-yours:show
    this._items         = null;
    this._productToCart = null;

    this._bindUI();
  }

  MakeItYoursModal.prototype = {

    // ── UI + system event bindings ───────────────────────────
    _bindUI: function () {
      var self = this;

      // product-form.js dispatches this instead of calling addToCart
      document.addEventListener('make-it-yours:show', function (e) {
        self._items         = e.detail.cartItems;
        self._productToCart = e.detail.productToCartEl;
        self.open();
      });

      // ShowTime variant:change — update image + overlay for new variant.
      // Fired by product-variant-selector.js via Core's publishEvent (capture phase).
      document.addEventListener('variant:change', function (e) {
        var variantId = e.detail && e.detail.data && e.detail.data.variantId;
        if (variantId) self._updateForVariant(variantId);
      }, true);

      // Live preview: filter to uppercase A-Z 0-9
      this.textInput.addEventListener('input', function (e) {
        var val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
        e.target.value = val;
        self.preview.textContent = val;
      });

      // Color selection → update preview color
      this.colorRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var hex = radio.getAttribute('data-miy-color') || COLOR_HEX[radio.value] || '#000000';
          self.preview.style.color = hex;
          if (self.colorError) self.colorError.hidden = true;
        });
      });

      this.addBtn.addEventListener('click',   this._onAdd.bind(this));
      this.laterBtn.addEventListener('click', this._onLater.bind(this));
      this.closeBtn.addEventListener('click', this._onDismiss.bind(this));
      this.backdrop.addEventListener('click', this._onDismiss.bind(this));

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.getAttribute('aria-hidden') !== 'true') {
          self._onDismiss();
        }
      });

      // Close modal and reset add-btn when cart responds
      document.addEventListener('cart:update', this._onCartResponse.bind(this), true);
      document.addEventListener('cart:error',  this._onCartResponse.bind(this), true);
    },

    // ── Update modal when variant changes ───────────────────
    _updateForVariant: function (variantId) {
      var data = this._variantData[variantId];
      if (!data) return;

      // Update product image
      if (this.productImg && data.image) {
        this.productImg.src = data.image;
      }

      // Update overlay position and font size
      if (this.preview) {
        this.preview.style.top      = data.top + '%';
        this.preview.style.left     = data.left + '%';
        this.preview.style.fontSize = data.fontSize + 'px';

        // Only update color if the user hasn't picked one yet in this session
        if (!this._selectedColor()) {
          this.preview.style.color = data.color;
        }
      }
    },

    // ── ADD TO CART (with personalization) ──────────────────
    _onAdd: function () {
      var text  = this.textInput.value;
      var color = this._selectedColor();

      if (!color) {
        if (this.colorError) this.colorError.hidden = false;
        return;
      }

      var items = this._cloneItems();
      if (text) {
        items[0].properties = { Text: text, TextColor: color };
      }

      this._setAddLoading(true);
      dispatchCartAdd(items);
      this._fixNotificationLabel();
    },

    // ── MAYBE LATER (no personalization) ────────────────────
    _onLater: function () {
      dispatchCartAdd(this._cloneItems());
      this.close();
    },

    // ── DISMISS without adding ───────────────────────────────
    _onDismiss: function () {
      this._resetPdpLoading();
      this.close();
    },

    // ── Cart responded (success or error) ───────────────────
    _onCartResponse: function () {
      this._setAddLoading(false);
      this.close();
    },

    // ── Open / Close ─────────────────────────────────────────
    open: function () {
      this._resetPdpLoading();
      this._resetForm();
      this.el.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      this.textInput.focus();
    },

    close: function () {
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    // ── Helpers ──────────────────────────────────────────────
    _resetPdpLoading: function () {
      if (this._productToCart) {
        var btn = this._productToCart.querySelector('[data-to-cart]');
        if (btn) btn.classList.remove('!loading');
      }
    },

    _selectedColor: function () {
      for (var i = 0; i < this.colorRadios.length; i++) {
        if (this.colorRadios[i].checked) return this.colorRadios[i].value;
      }
      return null;
    },

    _cloneItems: function () {
      return JSON.parse(JSON.stringify(this._items || []));
    },

    _setAddLoading: function (loading) {
      this.addBtn.disabled    = loading;
      this.addBtn.textContent = loading ? 'Adding…' : 'ADD TO CART';
    },

    _resetForm: function () {
      this.textInput.value = '';
      this.preview.textContent = '';
      this.colorRadios.forEach(function (r) { r.checked = false; });
      if (this.colorError) this.colorError.hidden = true;
      this._setAddLoading(false);
    },

    // Rename 'TextColor' → 'Text Color' in the cart notification popup
    _fixNotificationLabel: function () {
      var attempts = 0;
      var id = setInterval(function () {
        attempts++;
        var dl = document.querySelector('div.\\#cart-notification-product-info > dl');
        if (dl || attempts >= 20) {
          clearInterval(id);
          if (!dl) return;
          dl.querySelectorAll('.\\#cart-notification-product-info-option').forEach(function (opt) {
            var name = opt.querySelector('.\\#cart-notification-product-info-option-name');
            if (name && name.textContent.includes('TextColor')) {
              name.textContent = name.textContent.replace('TextColor', 'Text Color');
            }
          });
        }
      }, 100);
    }
  };

  // Init after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { new MakeItYoursModal(); });
  } else {
    new MakeItYoursModal();
  }
})();
